<template>
      <div class="more">
            <ul>
                  <li @click="goTradeRecord"><a>{{$t('trade.products.tradeRecord')}}</a><img src="@/assets/images/template/right_next_step.png"/></li>
                  <li @click="goEntrustRecord"><a>{{$t('trade.products.entrustRecord')}}</a><img src="@/assets/images/template/right_next_step.png"/></li>
                  <li @click="goProfitAndLossRecord"><a>{{$t('trade.products.profitAndLossRecord')}}</a><img src="@/assets/images/template/right_next_step.png"/></li>
                  <li @click="goCreditRecord"><a>{{$t('trade.products.creditRecord')}}</a><img src="@/assets/images/template/right_next_step.png"/></li>
            </ul>
      </div>
</template>

<script>
    import {mapState} from 'vuex'
    export default {
        name: "More",
        data() {
            return {
                token: "",
                wwwUrl: process.env.VUE_APP_WWW,
            }
        },
        computed: {
            ...mapState([ 'user','locale']),
        },
        methods:{
            goTradeRecord(){
                this.$bus.$emit('loading', false);
                let url=this.wwwUrl+'appTradeReport?token=' + this.user.token + '&typeName=trades&locale='+this.locale+'&pageType=trade&skinType=trade1&pattern=greenRed&timeZones=GMT+7';
                this.$router.push({
                    path: '/home/nesting', query: {
                        url: url,
                        title:this.$t('trade.products.tradeRecord')
                    },
                });
            },
            goEntrustRecord(){
                this.$bus.$emit('loading', false);
                let url=this.wwwUrl+'appTradeReport?token=' + this.user.token + '&typeName=order&locale='+this.locale+'&pageType=trade&skinType=trade1&pattern=greenRed&timeZones=GMT+7';
                this.$router.push({
                    path: '/home/nesting', query: {
                        url: url,
                        title:this.$t('trade.products.entrustRecord')
                    },
                });
            },
            goProfitAndLossRecord(){
                this.$bus.$emit('loading', false);
                let url=this.wwwUrl+'appTradeReport?token=' + this.user.token + '&typeName=profit&locale='+this.locale+'&pageType=trade&skinType=trade1&pattern=greenRed&timeZones=GMT+7';
                this.$router.push({
                    path: '/home/nesting', query: {
                        url: url,
                        title:this.$t('trade.products.profitAndLossRecord')
                    },
                });
            },
            goCreditRecord(){
                this.$bus.$emit('loading', false);
                let url=this.wwwUrl+'appTradeReport?token=' + this.user.token + '&typeName=balance&locale='+this.locale+'&pageType=trade&skinType=trade1&pattern=greenRed&timeZones=GMT+7';
                this.$router.push({
                    path: '/home/nesting', query: {
                        url: url,
                        title:this.$t('trade.products.creditRecord')
                    },
                });
            }
        },
    }
</script>
